import {createSelector} from "reselect"
import {RootState} from "redux/store"

export const getExportDestinations = createSelector(
  (state: RootState) => state.exportDestination.entities,
  (entities) => Object.values(entities)?.sort((a, b) => a.code.localeCompare(b.code)) ?? [],
)

